import { IconSettings } from "@tabler/icons-react";
import type { OadsSidebarItem } from "@oppizi-ecosystem/oads-sidebar";

// PAD-32065: shared so every OadsSidebar mount overrides the package default. Omitting
// footerItems falls back to buildClientFooter(), which points Settings at the LEGACY
// platform (/dashboard/client-settings) instead of next. Mirrors platform-next's
// OadsClientSidebar footer.
export const oadsSidebarFooterItems: OadsSidebarItem[] = [
  {
    name: "Settings",
    icon: <IconSettings size={20} stroke={1.75} />,
    platform: "next",
    href: "/dashboard/settings",
  },
];
